import React from "react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { shallow } from "zustand/shallow";
import {
    chekStartOrEndWithSpace,
    isValidEmail,
    // isValidPhoneNumber,
} from "@/utils/common";
import { PhoneInput } from "react-international-phone";
import Input from "../../common/Input";
import styles from "../../../styles/userPage/userPage.module.scss";
import inputStyles from "../../../styles/common/Input.module.scss";
import { useStore } from "../../../store";
import { IUser } from "../../../models/user";
import "react-international-phone/style.css";

const AccountInfo = () => {
    const { displayName, nameUser, surname, email, phone, bio } = useStore(
        state => ({
            displayName: state.userState.userDetail.displayName,
            nameUser: state.userState.userDetail.name,
            surname: state.userState.userDetail.surname,
            email: state.userState.userDetail.email,
            phone: state.userState.userDetail.phone,
            bio: state.userState.userDetail.bio,
        }),
        shallow
    );

    const dispatch = useStore(state => state.dispatchUser);

    const onChange = (e: {
        target: {
            name: keyof IUser;
            value: unknown;
        };
    }) => {
        const { name, value } = e.target;

        dispatch({
            type: "UPDATE_USER_DETAIL",
            payload: { [name]: value },
        });
    };

    return (
        <div>
            <p className={styles.title}>Account Info</p>

            <MDBRow>
                <MDBCol size={12} xl={10} className="my-2 ">
                    <Input
                        type="text"
                        onChange={onChange as never}
                        label="DISPLAY NAME"
                        name="displayName"
                        id="displayNameId"
                        value={displayName}
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol size={12} xl={5} className="my-2 ">
                    <Input
                        type="text"
                        onChange={onChange as never}
                        label="NAME"
                        name="name"
                        id="nameId"
                        required
                        value={nameUser}
                        validationCb={val =>
                            chekStartOrEndWithSpace(val as string)
                        }
                    />
                </MDBCol>
                <MDBCol size={12} xl={5} className="my-2 ">
                    <Input
                        type="text"
                        onChange={onChange as never}
                        label="SURNAME"
                        name="surname"
                        id="surnameId"
                        required
                        value={surname}
                        validationCb={val =>
                            chekStartOrEndWithSpace(val as string)
                        }
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol size={12} xl={5} className="my-2 ">
                    <Input
                        type="text"
                        onChange={onChange as never}
                        label="EMAIL"
                        name="email"
                        id="emailId"
                        value={email}
                        validationCb={val => isValidEmail(val as string)}
                        disabled
                    />
                </MDBCol>
                <MDBCol size={12} xl={5} className="my-2 ">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "start",
                        }}
                    >
                        <p
                            style={{
                                fontSize: "12px",
                                fontWeight: "400",
                                color: "#777e91",
                                marginBottom: "0.5rem",
                                // eslint-disable-next-line sonarjs/no-duplicate-string
                                fontFamily: "GeneralSans-Regular",
                            }}
                        >
                            CELLPHONE*
                        </p>
                        <PhoneInput
                            value={phone}
                            onChange={phoneInput => {
                                dispatch({
                                    type: "UPDATE_USER_DETAIL",
                                    payload: { phone: phoneInput as string },
                                });
                            }}
                            style={{ width: "100%" }}
                            inputStyle={{
                                height: "45px",
                                borderRadius: "0px 12px 12px 0px",
                                // eslint-disable-next-line sonarjs/no-duplicate-string
                                border: "2px solid #e6e8ec",
                                borderLeft: "none",
                                outline: "none",
                                width: "100%",
                            }}
                            countrySelectorStyleProps={{
                                style: {
                                    height: "45px",
                                    borderRadius: "12px 0 0 12px",
                                    border: "2px solid #e6e8ec",
                                    outline: "none",
                                    padding: "2px",
                                },
                                buttonStyle: {
                                    border: "none",
                                },
                            }}
                        />
                    </div>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol
                    size={12}
                    xl={10}
                    className={`${inputStyles.container} my-2 mb-4`}
                >
                    <p className="w-100">BIO</p>
                    <textarea
                        className={`${inputStyles.input} w-100`}
                        id="bioId"
                        name="bio"
                        onChange={onChange as never}
                        rows={5}
                        cols={60}
                        value={bio}
                        placeholder="Write about yourself in a few words"
                    />
                </MDBCol>
            </MDBRow>
        </div>
    );
};

export default AccountInfo;
